//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <BackgroundColorOverwrite :backgroundColor="'#fff'" class="go_background">
    <div class="go_results_page_container">
      <div class="go_results_content_container">
        <div class="go_results_details_container">
          <div class="go_results_info_container">
            <div class="go_heading_container">
              <div class="go_heading">
                {{ api.config.appConfig.offline_pages.ResultsPage.head_title }}
              </div>
              <div class="go_heading_sub">
                {{
                  api.config.appConfig.offline_pages.ResultsPage.second_title
                }}
              </div>
            </div>
            <table class="go_prescription_details">
              <thead>
                <tr>
                  <th></th>
                  <th>
                    {{
                      api.config.appConfig.offline_pages.ResultsPage
                        .prescription_sph_title
                    }}
                  </th>
                  <th>
                    {{
                      api.config.appConfig.offline_pages.ResultsPage
                        .prescription_cyl_title
                    }}
                  </th>
                  <th>
                    {{
                      api.config.appConfig.offline_pages.ResultsPage
                        .prescription_axis_title
                    }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>
                    {{
                      api.config.appConfig.offline_pages.ResultsPage
                        .prescription_right_title
                    }}<span>{{
                      api.config.appConfig.offline_pages.ResultsPage
                        .prescription_od_title
                    }}</span>
                  </th>
                  <td>{{ prescription_details.r_sph }}</td>
                  <td>{{ prescription_details.r_cyl }}</td>
                  <td>{{ prescription_details.r_axis }}</td>
                </tr>
                <tr>
                  <th>
                    {{
                      api.config.appConfig.offline_pages.ResultsPage
                        .prescription_left_title
                    }}<span>{{
                      api.config.appConfig.offline_pages.ResultsPage
                        .prescription_os_title
                    }}</span>
                  </th>
                  <td>{{ prescription_details.l_sph }}</td>
                  <td>{{ prescription_details.l_cyl }}</td>
                  <td>{{ prescription_details.l_axis }}</td>
                </tr>
                <tr v-if="havePd()">
                  <th>
                    {{
                      api.config.appConfig.offline_pages.ResultsPage
                        .prescription_pd_title
                    }}
                  </th>
                  <td class="go_pd" colspan="3">
                    {{ prescription_details.pd }}
                    {{
                      api.config.appConfig.offline_pages.ResultsPage
                        .prescription_pd_unit_title
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              class="go_btn_container"
              v-if="
                store.state.resultsPageInfo.btns &&
                store.state.resultsPageInfo.btns.length
              "
            >
              <div
                v-for="(btnInfo, index) in store.state.resultsPageInfo.btns"
                :key="btnInfo.title + index"
              >
                <div
                  :class="[
                    'go_btn',
                    store.state.resultsPageInfo.btns.length === 1
                      ? 'go_primary_only'
                      : null,
                  ]"
                  @click="customButtonClick(btnInfo, index)"
                  :style="shopButtonsStyle"
                >
                  <div v-if="buttonsSpinner[index]" class="spinner-container">
                    <div class="spinner-wrapper">
                      <SmallSpinner />
                    </div>
                  </div>
                  <span v-else>
                    {{ btnInfo.title }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="go_results_tested_container">
          <span class="go_text">{{
            api.config.appConfig.offline_pages.ResultsPage.footer
          }}</span>
        </div>
      </div>
    </div>
  </BackgroundColorOverwrite>
</template>

<script setup>
import AnalyticsEvent from "@/../../../common/models/AnalyticsEvent.js";

import SmallSpinner from "@/components/icons/SmallSpinner.vue";
import BackgroundColorOverwrite from "@/components/BackgroundColorOverwrite.vue";

import { useStore } from "vuex";
import { inject, ref, computed, onMounted, defineProps } from "vue";

const api = inject("api");
const store = useStore();

defineProps(["imgSrc"]);

const buttonsSpinner = ref([]);

const prescription_details = computed(function () {
  return store.state.Results.prescription;
});

const shopButtonsStyle = computed(function () {
  return {
    "--background": store.state.Style.themeColor,
  };
});

function performAction(btnInfo, index) {
  buttonsSpinner.value[index] = 0;
  btnInfo.action();
}

function customButtonClick(btnInfo, index) {
  buttonsSpinner.value[index] = 1;
  api.analytics.log(
    new AnalyticsEvent("act web results " + index, "act", "good")
  );
  setTimeout(() => {
    performAction(btnInfo, index);
  }, 2000);
}

function havePd() {
  const pd = parseFloat(store.state.Results.prescription.pd);
  return !isNaN(pd) && pd > 0;
}

onMounted(function () {
  api.analytics.log(new AnalyticsEvent("pv web results", "pv", "good"));
});
</script>

<style lang="scss" scoped>
.go_background {
  touch-action: auto !important;
  overflow: scroll;
  width: 100%;
  min-height: 100%;
  padding: 0 !important;
  justify-content: flex-start !important;
}
.go_results_page_container {
  display: flex;
  justify-content: center;
  font-size: 18px;
  height: 100%;
  margin-top: 6%;

  @include mobile {
    width: 100%;
    padding: 65px 30px !important;
  }

  @include desktop {
    max-width: 1425px;
  }

  .go_results_content_container {
    max-width: 1200px;
    display: flex;
    flex-direction: column;

    .go_results_details_container {
      display: flex;
      justify-content: space-between;

      @include mobile {
        flex-direction: column;
        align-items: center;
      }

      @include tablet {
        flex-direction: column;
        align-items: center;
      }

      .go_results_info_container {
        max-width: 485px;

        .go_heading_container {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          margin-bottom: 40px;

          .go_heading {
            font-weight: 700;
            font-size: 30px;
            line-height: 42px;

            @include mobile {
              font-size: 24px;
              line-height: 30px;
            }
          }

          .go_heading_sub {
            margin-top: 18px;
            font-weight: 700;
            font-size: 18px;
            line-height: 28px;
            text-align: left;

            @include mobile {
              margin-top: 6px;
              font-size: 16px;
              line-height: 30px;
              width: 330px;
              text-align: center;
            }
          }

          @include mobile {
            text-align: center;
            align-items: center;
          }

          @include tablet {
            text-align: center;
            align-items: center;
          }

          .go_subtitle {
            margin-top: 20px;
            font-size: 22px;
            @include mobile {
              font-size: 17px;
            }
          }
        }

        .go_prescription_details {
          width: 460px;
          height: 256px;
          border: 1px solid #bec0c1;
          box-shadow: 0px 0px 10px 0px #00000021;

          @include mobile {
            width: 350px;
            margin: 0 35px;
          }

          tr {
            td,
            th {
              height: 55px;
              border-bottom: 1px solid #d7dbdc;
              &:last-child {
                padding-right: 25px;
              }
              span {
                font-size: 15px;
                font-weight: 400;

                @include mobile {
                  font-size: 12px;
                }
              }
            }

            &:last-child {
              td,
              th {
                border-bottom: none;
              }
            }

            th {
              font-size: 20px;
              font-weight: bold;
              @include mobile {
                font-size: 13px;
              }
            }

            td {
              font-size: 25px;
              font-weight: 300;
              padding: 0 35px;
              @include mobile {
                font-size: 17px;
                padding: 0 30px;
              }
            }
          }

          tbody {
            tr {
              th {
                text-align: left;
                padding-left: 25px;
              }
            }

            .go_pd {
              text-align: center;
            }
          }
        }

        .go_btn_container {
          display: flex;
          justify-content: space-between;
          margin-top: 30px;
          flex-wrap: wrap;

          @include mobile {
            flex-wrap: nowrap;
            justify-content: center;
          }

          .go_btn {
            background: var(--background);
            height: 55px;
            color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 40px;
            padding: 0 30px;
            min-width: 210px;
            cursor: pointer;
            margin-bottom: 10px;
            flex-grow: 1;
            margin-right: 30px;

            @include mobile {
              min-width: 150px;
              margin: 0 30px;
              padding: 0 20px;
              height: 45px;
            }
          }

          .spinner-container {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;

            @keyframes spinner {
              to {
                transform: rotate(360deg);
              }
            }

            .spinner-wrapper {
              height: 24px;
              width: 24px;
              position: relative;
              svg {
                fill: white;
                height: 24px;
                width: 24px;
                animation: spinner 1s linear infinite;
              }
            }
          }
        }
      }

      .go_results_image_container {
        padding-top: 50px;

        .go_frame_one {
          @include mobile {
            width: 330px;
            margin-left: -25px;
          }

          @include tablet {
            width: 400px;
            margin-left: -40px;
          }

          @include desktop_small {
            width: 421px;
          }
        }
      }
    }
    .go_results_tested_container {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 80px;
      padding: 0 0 20px;
      width: 473px;
      font-size: 14px;
      font-weight: 300;
      line-height: 28px;
      text-align: left;

      @include mobile {
        .go_text {
          text-align: center;
          width: 330px;
        }
      }
    }
  }
}
</style>
